import React from 'react';

import Container from '../../../Container/Container';

import RMFUSPAFinishPrompt from './components/RMFUSPAFinishPrompt';

const RMFUSPAFinishScreen: React.FC = () => (
  <Container
    page={RMFUSPAFinishScreen}
    headerProps={{
      title: '',
      buttons: { back: false }
    }}
  >
    <RMFUSPAFinishPrompt />
  </Container>
);

RMFUSPAFinishScreen.displayName = 'RMFUSPAFinishScreen';

export default RMFUSPAFinishScreen;
